import React, { useState,useEffect } from 'react'
import { Container, Row, Col, Offcanvas, Nav, Navbar, Button } from 'react-bootstrap'
import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import Footer from '../components/Footer'
import Swal from 'sweetalert2'
import axios from 'axios'
import biswabangla from '../assets/images/biswabangla.png';


export default function MainLayout() {
  const [showSidebar, setShowSidebar] = useState(false);
  const [vendorType, setvendorType] = useState(false);
  const navigate = useNavigate()
  const location = useLocation()
const [openMenu, setOpenMenu] = useState([]);
const [showUserMenu, setShowUserMenu] = useState(false);

  const handleClose = () => setShowSidebar(false)
  const handleShow = () => setShowSidebar(true)
   const muniName = localStorage.getItem("name");

  const user_type_id = localStorage.getItem('userTypeId');

  const fetchVendorType = async() =>{
    const token = localStorage.getItem('token');
    try{
        const res = await axios.post(`https://sutmmgdev.codydeasoftech.in/api/vendorTypesList`,
            {},
            {headers: {Authorization: `Bearer ${token}`}}
        )
        if(res.data.status === true){
            setvendorType(res.data.data);
            console.log(res.data.data)
        }
    }catch(err){

    }
  }



useEffect(() => {
  if (user_type_id === "2") {
    fetchVendorType();
  }
}, [user_type_id]);

const getVendorMenus = () => {
    if (!vendorType.length) return [];
  return vendorType
    .filter(v => v.status === 1 || v.active_stat === 1)
    .sort((a, b) => a.ordering - b.ordering)
    .map(v => ({
      name: `${v.vendor_type_short_name} Master`,
      path: `/app/${v.slug}`,
      icon: `${v.icon_class}`,
    }));
};








  const role1Menus = [



    { name: "Dashboard", path: "/app/dashboard", icon: "fa-house" },

    {
    name: "Master",
    icon: "fa-database",
    children: [
      {
        name: "Items",
        path: "/app/item",
        icon: "fa-box",
      },
      {
        name: "Sizes",
        path: "/app/size-list",
        icon: "fa-ruler",
      },
      {
        name: "Fabric Consumptions",
        path: "/app/fabric-consumptions",
        icon: "fa-chart-pie",
      },
      {
        name: "Rate Charts",
        path: "/app/job-worker-rate-list",
        icon: "fa-indian-rupee-sign",
      },
      {
        name: "School Categories",
        path: "/app/category-list",
        icon: "fa-layer-group",
      },
      {
        name: "School Management Types",
        path: "/app/school-management-types",
        icon: "fa-school",
      },
      {
        name: "School Types",
        path: "/app/school-types",
        icon: "fa-list",
      },

    ],
  },


  {
  name: "System Settings",
  icon: "fa-clipboard-list",
  children: [
    {
      name: "Academic Year",
      path: "/app/academic-year",
      icon: "fa-calendar-days",
    },
    {
      name: "Zone",
      path: "/app/zone",
      icon: "fa-location-crosshairs",
    },
    {
      name: "District",
      path: "/app/district",
      icon: "fa-city",
    },
    {
      name: "Sub Division",
      path: "/app/sub-div",
      icon: "fa-map-location",
    },
    {
      name: "Circle",
      path: "/app/circle",
      icon: "fa-location-dot",
    },
  ],
},






    // { name: "Academic Year", path: "/app/academic-year", icon: "fa-calendar-days" },
    // { name: "Zone", path: "/app/zone", icon: "fa-location-crosshairs" },
    // { name: "District", path: "/app/district", icon: "fa-city" },
    // { name: "Sub Division", path: "/app/sub-div", icon: "fa-map-location" },
    // { name: "Circle", path: "/app/circle", icon: "fa-location-dot" },
    { name: "Municipalities", path: "/app/municipality", icon: "fa-user" },
{
  name: "Reports",
  icon: "fa-list-ul",
  children: [
    {
      name: "Measurements Count Report",
      path: "/app/measurement-count-report",
      icon: "fa-clipboard",
    },
    // {
    //   name: "Overview",
    //   path: "/app/reports-overview",
    //   icon: "fa-chart-pie",
    // },
  ],
},



    // { name: "Items", path: "/app/item", icon: "fa-box" },
    // { name: "Job-Worker Rate Chart", path: "/app/job-worker-rate-list", icon: "fa-layer-group" },
    // { name: "Size Master", path: "/app/size-list", icon: "fa-shirt" },
    // { name: "Fabric Consumptions", path: "/app/fabric-consumptions", icon: "fa-shirt" },
    // { name: "School Categories", path: "/app/category-list", icon: "fa-rectangle-list" },
    // { name: "School Types", path: "/app/school-types", icon: "fa-hand-holding" },
    // { name: "School Management Types", path: "/app/school-management-types", icon: "fa-chart-column" },
]

  const role2Menus = [
    { name: "Dashboard", path: "/app/dashboard", icon: "fa-house" },

     {
    name: "Master",
    icon: "fa-database",
    children: [
      {
        name: "Items",
        path: "/app/item",
        icon: "fa-box",
      },
      {
        name: "Sizes",
        path: "/app/size-list",
        icon: "fa-ruler",
      },
      {
        name: "Fabric Consumptions",
        path: "/app/fabric-consumptions",
        icon: "fa-chart-pie",
      },
      {
        name: "Rate Charts",
        path: "/app/job-worker-rate-list",
        icon: "fa-indian-rupee-sign",
      },
      {
        name: "School Categories",
        path: "/app/category-list",
        icon: "fa-layer-group",
      },
      {
        name: "School Management Types",
        path: "/app/school-management-types",
        icon: "fa-school",
      },
      {
        name: "School Types",
        path: "/app/school-types",
        icon: "fa-list",
      },

    ],
  },

    { name: "Schools", path: "/app/school", icon: "fa-school" },
    {
  name: "Vendors",
  icon: "fa-industry",
  children: [
    ...getVendorMenus(),
        { name: "SHG Members", path: "/app/member", icon: "fa-user-group" },

  ],
},


    {
  name: "Measurement",
  icon: "fa-ruler-combined",
  children: [
    {
      name: "Add Measurement",
      path: "/app/measurement-list",
      icon: "fa-store",
    },
    {
      name: "Measurement Overview",
      path: "/app/overview-list",
      icon: "fa-file-invoice",
    },
  ],
},



    { name: "Fabric Procurement", path: "/app/fabric-procure", icon: "fa-shirt" },
    { name: "Issue Cutpiece", path: "/app/issue-cutpiece", icon: "fa-box" },
    { name: "Receive Cut Piece ", path: "/app/receive-cut-piece", icon: "fa-box" },
    { name: "Issue Other Job Works", path: "/app/issue-job-work", icon: "fa-box" },
    { name: "Job Worker Payments", path: "/app/transaction-list", icon: "fa-right-left" },
    {
  name: "Reports",
  icon: "fa-list-ul",
  children: [
    {
      name: "Measurements Count Report",
      path: "/app/measurement-count-report",
      icon: "fa-clipboard",
    },

  ],
},





  ]

 const role3Menus = [

  { name: "Dashboard",
    path: "/app/dashboard",
    icon: "fa-house",
  },

  {
    name: "Receive Fabric",
    path: "/app/cutting-vendor/receive-fabric",
    icon: "fa-download",
  },
  {
    name: "Order Lists",
    path: "/app/cutting-vendor/order-list",
    icon: "fa-list",
  },
  {
    name: "Inventory",
    path: "/app/cutting-vendor/inventory",
    icon: "fa-scissors",
  },

  {
    name: "Dispatch",
    path: "/app/cutting-vendor/dispatch",
    icon: "fa-truck-arrow-right",
  },

];



  let menus = []
  if (user_type_id === "1") menus = role1Menus
  else if (user_type_id === "2") menus = role2Menus
  else if (user_type_id === "3") menus = role3Menus

const logout = () => {
  Swal.fire({
    title: "Are you sure?",
    text: "You will be logged out from the system!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, logout",
    cancelButtonText: "Cancel",
  }).then((result) => {
    if (result.isConfirmed) {
      let token = localStorage.getItem("token")
      let userType = localStorage.getItem("userTypeId")   // 👈 get saved user type

      axios
        .get("https://sutmmgdev.codydeasoftech.in/api/logout", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(() => {
          localStorage.clear()

          if (userType === "1") {
            navigate("/suda/login")
          } else if (userType === "2") {
            navigate("/ulb/login")
          } else {
            navigate("/landing")
          }
        })
        .catch(() => {
          localStorage.clear()
          navigate("/landing")
        })
    }
  })
}




return (
  <>
    <Navbar
      expand="lg"
      className="px-4 fixed-top shadow-lg py-1"
      style={{
        background: "linear-gradient(90deg, #0D47A1, #1565C1)",borderBottom: "1px solid white"

      }}
    >
      <Button
        className="me-3 d-lg-none border-0"
        style={{ background: "#00695c" }}
        onClick={handleShow}
      >
        <i className="fa-solid fa-bars text-white"></i>
      </Button>

      <Navbar.Brand className="d-flex align-items-center gap-3 text-white fw-bold">

          <img src={biswabangla} style={{ width:"40px", height: "45px" }} />

        {/* Urban School Uniform Stitching Project Management System */}
        Smart Urban Uniform Management System
      </Navbar.Brand>
    </Navbar>

    <Navbar
  expand="lg"
  className="px-4 fixed-top shadow-lg py-1"
  style={{
    background: "linear-gradient(90deg, #0D47A1, #1565C1)",
    borderBottom: "1px solid white",
  }}
>
  <Button
    className="me-3 d-lg-none border-0"
    style={{ background: "#00695c" }}
    onClick={handleShow}
  >
    <i className="fa-solid fa-bars text-white"></i>
  </Button>

  <Navbar.Brand className="d-flex align-items-center gap-3 text-white fw-bold">
    <img
      src={biswabangla}
      alt="Logo"
      style={{ width: "40px", height: "45px" }}
    />
    {/* Urban School Uniform Stitching Project Management System */}

    Smart Urban Uniform Management System
  </Navbar.Brand>



{muniName && (
  <div
    className="ms-auto d-none d-lg-flex position-relative align-items-center gap-3"
    style={{ cursor: "pointer" }}
    onClick={() => setShowUserMenu(!showUserMenu)}
  >
    <div
      style={{
        width: "33px",
        height: "33px",
        borderRadius: "50%",
        border: "2px solid #E3F2FD",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <i
        className="fa-solid fa-user"
        style={{ color: "#E3F2FD", fontSize: "16px" }}
      ></i>
    </div>

    <span
      style={{
        fontWeight: "600",
        color: "#E3F2FD",
        fontSize: "18px",
        letterSpacing: "0.5px",
      }}
    >
      {muniName}
      <i className="fa-solid fa-chevron-down ms-2" style={{ fontSize: "12px" }} />
    </span>

    {showUserMenu && (
      <div
        style={{
          position: "absolute",
          top: "45px",
          right: "0",
          background: "white",
          borderRadius: "8px",
          minWidth: "180px",
          boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
          overflow: "hidden",
          zIndex: 9999,
        }}
      >
        <div
          className="px-3 py-2 d-flex align-items-center gap-2"
          style={{ cursor: "pointer" }}
                 onClick={() => Swal.fire("Information", "This facility will be available soon.", "info")}
        >
          <i className="fa-solid fa-user text-primary"></i>
          Profile
        </div>

        <div
          className="px-3 py-2 d-flex align-items-center gap-2"
          style={{ cursor: "pointer" }}
                 onClick={() => Swal.fire("Information", "This facility will be available soon.", "info")}
        >
          <i className="fa-solid fa-key text-warning"></i>
          Change Password
        </div>

        <div
          className="px-3 py-2 d-flex align-items-center gap-2 text-danger"
          style={{ cursor: "pointer", borderTop: "1px solid #eee" }}
          onClick={() => {
            setShowUserMenu(false);
            logout();
          }}
        >
          <i className="fa-solid fa-arrow-right-from-bracket"></i>
          Logout
        </div>
      </div>
    )}
  </div>
)}



</Navbar>




    <Offcanvas
  show={showSidebar}
  onHide={handleClose}
  placement="start"
  className="d-lg-none"
>
  <Offcanvas.Header closeButton>
    <Offcanvas.Title>Menu</Offcanvas.Title>
  </Offcanvas.Header>

  <Offcanvas.Body
    style={{
      background: "linear-gradient(180deg, #1565C1, #0D47A1)",
      padding: "15px",
    }}
  >
    <Nav className="flex-column gap-2">
      {menus.map((item, index) => (
        <Nav.Link
          key={index}
          className="text-white"
          onClick={() => {
            navigate(item.path)
            handleClose()
          }}
        >
          <i className={`fa-solid ${item.icon} me-3`}></i>
          {item.name}
        </Nav.Link>
      ))}







      <Nav.Link
        className="text-white mt-3"
        onClick={() => {
          handleClose()
          logout()
        }}
      >
        <i className="fa-solid fa-arrow-right-from-bracket me-3"></i>
        Logout
      </Nav.Link>
    </Nav>
  </Offcanvas.Body>
</Offcanvas>


    <Container fluid>
  <Row>
    {/* ✅ DESKTOP SIDEBAR */}
    <Col
  lg={2}
  className="d-none d-lg-block position-fixed top-0 start-0 vh-100 p-3 overflow-auto shadow-lg"
  style={{
    marginTop: "60px",
    background: "linear-gradient(180deg, #1565C1, #0D47A1)",
  }}
>
  <Nav className="flex-column gap-2 mt-3">

    {menus.map((menu, index) => {
  const menuKey = menu.title || menu.name;
  const isActive = location.pathname === menu.path;

  return (
    <div key={index}>
      {/* Parent */}
      <Nav.Link
        className="d-flex align-items-center py-2 px-3 rounded"
        style={{
          background: isActive ? "#E3F2FD" : "transparent",
          color: isActive ? "#1565C1" : "white",
          fontWeight: isActive ? "700" : "500",
        }}
        onClick={() => {
          if (menu.children) {
  if (openMenu.includes(menuKey)) {
    setOpenMenu(openMenu.filter((m) => m !== menuKey));
  } else {
    setOpenMenu([...openMenu, menuKey]);
  }
} else {
  navigate(menu.path);
}

        }}
      >
        <i className={`fa-solid ${menu.icon} me-3`}></i>
        {menuKey}

        {menu.children && (
          <i
            className={`fa-solid fa-chevron-${
              openMenu === menuKey ? "up" : "down"
            } ms-auto`}
          />
        )}
      </Nav.Link>

{menu.children && openMenu.includes(menuKey) && (
        <div className="ms-4 ">
          {menu.children.map((child, i) => {
            const isChildActive = location.pathname === child.path;

            return (
              <Nav.Link
                key={i}
                className="py-1 mb-2"
                style={{
                  fontSize: "16px",
                  color: isChildActive ? "#BBDEFB" : "white",
                  fontWeight: isChildActive ? "600" : "400",
                }}
                onClick={() => navigate(child.path)}
              >
                <i className={`fa-solid ${child.icon} me-2`}></i>
                {child.name}
              </Nav.Link>
            );
          })}
        </div>
      )}
    </div>
  );
})}


    {/* ✅ LOGOUT BUTTON */}
    {/* <Nav.Link
      className="d-flex align-items-center py-2 px-3 rounded text-white mt-4"
      style={{
        background: "linear-gradient(90deg, #E53935, #D32F2F)",
        boxShadow: "0 4px 12px rgba(229,57,53,0.6)",
        transition: "0.3s",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.05)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
      }}
      onClick={logout}
    >
      <i className="fa-solid fa-arrow-right-from-bracket me-3"></i>
      Logout
    </Nav.Link> */}

  </Nav>
</Col>


    {/* ✅ MAIN CONTENT */}
    <Col
      xs={12}
      lg={{ span: 10, offset: 2 }}
      className="d-flex flex-column min-vh-100  pb-0"
      style={{
        paddingTop: "75px",
        background: "#F4F8FF",
      }}
    >
      <div
        className="flex-grow-1 pb-5  rounded shadow-sm"
        style={{
          background: "white",
          padding: "25px",
        }}
      >
        <Outlet />
      </div>

      <Footer />
    </Col>
  </Row>
</Container>

  </>
);





}
